import { render, staticRenderFns } from "./DoubleBubbleTransition.vue?vue&type=template&id=2d4c6c5e&scoped=true&"
import script from "./DoubleBubbleTransition.vue?vue&type=script&lang=js&"
export * from "./DoubleBubbleTransition.vue?vue&type=script&lang=js&"
import style0 from "./DoubleBubbleTransition.vue?vue&type=style&index=0&id=2d4c6c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4c6c5e",
  null
  
)

export default component.exports